module.exports = __webpack_public_path__ + "img/exit.3734d2db.svg";